import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import './FormSection.css';

/**
 * FormSection - Sección que contiene un formulario dinámico
 */
const FormSection = ({ formConfig }) => {
  return (
    <section className="form-section">
      <DynamicForm formConfig={formConfig} />
    </section>
  );
};

export default FormSection;
